@if (personaSystemAnswerCustomResponseForm) {
  <yc-modal
    [formGroup]="personaSystemAnswerCustomResponseForm"
    [modalHeader]="title"
    [cancelButtonText]="'common:btnCancel' | ycI18n"
    [primaryButtonText]="'common:btnSave' | ycI18n"
    [primaryButtonId]="'primaryBtn'"
    [primaryDisabled]="personaSystemAnswerCustomResponseForm.invalid"
    (onCancel)="_onCancel()"
    (onPrimaryClick)="_onSubmit()">
    <div>
      {{ systemQuestion }}
    </div>
    <div>
      <yc-textarea
        name="userCustomResponse"
        [label]="systemAnswer"
        [addRequiredAsterisk]="true">
      </yc-textarea>
    </div>
  </yc-modal>
}